import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SimpleSelect } from "@/components/app/common";

export function useMarche() {
  const [marche, setMarche] = useState([]);
  useEffect(() => { api.get("/marche").then((r) => setMarche(r.data)).catch(() => setMarche([])); }, []);
  return marche;
}

export const MarcaSelect = ({ marche, value, onChange, testId = "marca-filter-select", className = "w-48" }) => (
  <SimpleSelect testId={testId} className={className} value={value} onChange={onChange}
    options={[{ value: "all", label: "Tutte le marche" }, ...marche.map((m) => ({ value: m.id, label: m.nome }))]} />
);

export const MarcaBadge = ({ nome }) => nome ? <span className="text-xs px-2 py-0.5 rounded-full bg-[#8C6D62]/10 text-[#5E4A42] whitespace-nowrap">{nome}</span> : <span className="text-xs text-[#756B64]">—</span>;
